import { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import sanityClient from "../client";

import Filters from "../components/Projects/Filters";
import ProjectItem from "../components/Projects/ProjectItem";
import Loading from "../components/global/Loading";

import "./Projects.scss";

const AllProjects = (props) => {
  const { setLogoIsSmall } = props;
  const [pageData, setPageData] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);
  const [currentVideo, setCurrentVideo] = useState(null);

  const imageWrapper = useRef();
  const videoWrapper = useRef();

  useEffect(() => {
    setLogoIsSmall(true);
  });

  // useEffect(() => {
  //   sanityClient
  //     .fetch(`*[_type == "projects"]|order(orderRank)`)
  //     .then((data) => {
  //       setPageData(data);
  //     })
  //     .catch();
  // }, []);

 useEffect(() => {
    sanityClient
      .fetch(
        `*[_type == "projects" && projectFilters.documentary == true]{
          title,
          client,
          previewVideo,
          heroImage,
          slug,
          _id,
          orderRank,
          projectFilters,
        }|order(orderRank)`,
      )
      .then((data) => {
        setPageData(data);
      })
      .catch();
  }, []);

  if (pageData) {
    console.log(pageData);
    return (
      <motion.main
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { duration: 0.4 } }}
        exit={{ opacity: 0, transition: { duration: 0.4 } }}
        className="projects__outer-wrapper"
      >
        <Filters />
        <div className="projects__media-wrapper">
          <img
            src={currentImage}
            alt=""
            ref={imageWrapper}
            className={`projects__media-image ${currentImage && !currentVideo ? "active" : ""}`}
          />
          <video
            src={currentVideo}
            ref={videoWrapper}
            loop
            muted
            autoPlay
            playsInline
            background="true"
            className={`projects__media-video ${currentVideo ? "active" : ""}`}
          />
        </div>
        {pageData.map((project) => (
          <ProjectItem
            key={project._id}
            project={project}
            setCurrentImage={setCurrentImage}
            setCurrentVideo={setCurrentVideo}
          />
        ))}
      </motion.main>
    );
  } else {
    return <Loading />;
  }
};

export default AllProjects;
